import { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';
import { T } from '../styles/theme';

const categorieBadge = {
  Vinted: 'badge-cyan',
  eBay: 'badge-amber',
  Mindset: 'badge-violet',
  Fotografia: 'badge-green',
  Prezzi: 'badge-red',
};

export default function GuidePage() {
  const [guide, setGuide] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('Tutte');
  const categorie = ['Tutte', 'Vinted', 'eBay', 'Mindset', 'Fotografia', 'Prezzi'];

  useEffect(() => {
    api.get('/guide').then((r) => setGuide(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = filtro === 'Tutte' ? guide : guide.filter((g) => g.categoria === filtro);
  const formatDate = (d) => d ? new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';

  return (
    <Layout>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <h1 className="page-title" style={{ color: T.violet }}>Guide</h1>
          <p className="text-sm mt-1" style={{ color: T.muted }}>Impara le migliori strategie per vendere online</p>
        </div>

        {/* Filtri */}
        <div className="flex flex-wrap gap-2 mb-6">
          {categorie.map((c) => (
            <button key={c} onClick={() => setFiltro(c)}
              className={`px-4 py-2 rounded-lg text-xs font-semibold transition-all ${filtro === c ? 'btn-primary' : ''}`}
              style={filtro === c ? {} : {
                backgroundColor: T.card,
                color: T.muted,
                border: `1px solid ${T.border}`,
              }}>
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-16" style={{ color: T.muted }}>Caricamento...</div>
        ) : filtered.length === 0 ? (
          <div className="card text-center py-16">
            <p className="text-lg" style={{ color: T.muted }}>Nessuna guida disponibile</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filtered.map((g) => {
              const badgeCls = categorieBadge[g.categoria] || 'badge-violet';
              return (
                <div key={g.id} className="card p-5 transition-all hover:scale-[1.01]">
                  <div className="flex items-center justify-between mb-3">
                    <span className={`badge ${badgeCls}`}>{g.categoria}</span>
                    <span className="text-[11px]" style={{ color: T.muted }}>{formatDate(g.created_at)}</span>
                  </div>
                  <h3 className="font-bold text-lg mb-2" style={{ color: T.text }}>{ g.titolo}</h3>
                  <p className="text-sm leading-relaxed whitespace-pre-wrap" style={{ color: T.muted }}>{g.contenuto}</p>
                </div>
              );
            })}
          </div>
        )}
      </main>    </Layout>
  );
}
